import { EEirSalesSimType } from "@mappers/getCartMapper";

interface IInclusiveEquipmentPayload {
    simCardType: EEirSalesSimType;
}

export const mapInclusiveEquipmentPayload = (simCardType: EEirSalesSimType): IInclusiveEquipmentPayload => ({
    simCardType,
});
